import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "neighborhood-container"
}
const _hoisted_2 = { class: "flexDiv mb-10" }
const _hoisted_3 = {
  key: 0,
  class: "carousel-navigation"
}

import { ref, toRefs, watch, onMounted, computed } from 'vue';
import { Carousel, Navigation, Slide } from 'vue3-carousel';
import type {
  NeighboorhoodCoords,
  NeighborhoodPlanQmiCounts,
  NeighborhoodPlatMap,
  NeighborhoodSoldDetails,
  Sibling,
} from '../types';
import NeighborhoodItem from './AppHeaderNeighborhoodListItem.vue';
import AppHeaderCircle from './AppHeaderCircle.vue';

interface Props {
  coordinates?: NeighborhoodPlatMap[];
  siblings: Sibling[];
  soldPercentage: NeighborhoodSoldDetails[];
  selectedNeighborhoodIds: string[];
  neighborhoodsPlanQmiCount: NeighborhoodPlanQmiCounts[];
  qmiFilter: boolean;
  isAnyFilterApplied: boolean;
  totalMobileFilterApplied: number;
  neighborhoodLotsCount: (neighborhoodId: string) => number;
  isComingSoon: (sibling: Sibling) => boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeaderNeighborhoodList',
  props: {
    coordinates: {},
    siblings: {},
    soldPercentage: {},
    selectedNeighborhoodIds: {},
    neighborhoodsPlanQmiCount: {},
    qmiFilter: { type: Boolean },
    isAnyFilterApplied: { type: Boolean },
    totalMobileFilterApplied: {},
    neighborhoodLotsCount: { type: Function },
    isComingSoon: { type: Function }
  },
  emits: [
  'sethoverNeighborZoomLevel',
  'loadNeighborhood',
  'hideSibling',
  'clearSelectedNeighborhoods',
  'selectNeighborhood',
  'highlightNeighborhood',
],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const {
  coordinates,
  siblings,
  soldPercentage,
  selectedNeighborhoodIds,
  isAnyFilterApplied,
  totalMobileFilterApplied,
  neighborhoodsPlanQmiCount,
  isComingSoon,
} = toRefs(props);

const carouselConfig = {
  itemsToShow: 1.4,
  itemsToScroll: 1,
  wrapAround: false,
};

const slick = ref<any>(null);
const currentSlide = ref(0);
const emit = __emit;

const sethoverNeighborZoomLevel = (payload: {
  zoomLevel: number;
  isDisableHoverNeighbor: boolean;
  centerMap: NeighboorhoodCoords;
}) => {
  emit('sethoverNeighborZoomLevel', payload);
};

const loadNeighborhood = (payload: {
  areaName: string;
  communityName: string;
  neighborhoodName: string;
}) => {
  emit('loadNeighborhood', payload);
};

const hideSibling = () => emit('hideSibling');
const clearSelectedNeighborhoods = () => emit('clearSelectedNeighborhoods');
const selectNeighborhood = (neighborhoodId: string, idx) => {
  currentSlide.value = idx;
  emit('selectNeighborhood', neighborhoodId);
};
const highlightNeighborhood = (payload: {
  neighborhoodId: string;
  display: string;
}) => emit('highlightNeighborhood', payload);

const checkAndClearNeighborhood = () => {
  if (
    isAnyFilterApplied.value ||
    selectedNeighborhoodIds.value.length ||
    totalMobileFilterApplied.value
  ) {
    currentSlide.value = 0;
    clearSelectedNeighborhoods();
  }
};

const showClearButton = computed(() => {
  return (
    isAnyFilterApplied.value ||
    selectedNeighborhoodIds.value.length ||
    totalMobileFilterApplied.value
  );
});

const previewCurrentNeighborhood = () => {
  if (selectedNeighborhoodIds.value.length) {
    const currentNeighborhoodIndex = siblings.value.findIndex(
      (s) => s.id === selectedNeighborhoodIds.value[0]
    );
    currentSlide.value = currentNeighborhoodIndex;
  }
};

watch(selectedNeighborhoodIds, () => {
  previewCurrentNeighborhood();
}, { deep: true });

onMounted(() => {
  previewCurrentNeighborhood();
});

const neighborhoodSoldPercentage = (neighborhoodId: string) => {
  const value = soldPercentage.value.find(
    (p) => p.neighborhoodId === neighborhoodId
  )?.soldPercentage;
  return value ? value : 0;
};
// const neighborhoodPlanQmisCount = (neighborhodId: string) => {
//   return neighborhoodsPlanQmiCount.value.find(
//     (neighborhood) => neighborhood.neighborhoodId === neighborhodId
//   );
// };

return (_ctx: any,_cache: any) => {
  return (_unref(siblings).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "neighborhood-title" }, "Select a Neighborhood", -1)),
          (showClearButton.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: checkAndClearNeighborhood,
                class: "btn-clr neighborhood-btn"
              }, " Clear "))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_unref(Carousel), _mergeProps({ class: "embheader_slider_wrap" }, carouselConfig, {
          modelValue: currentSlide.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentSlide).value = $event))
        }), {
          addons: _withCtx(() => [
            (_unref(siblings).length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_unref(Navigation))
                ]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(siblings), (sibling, idx) => {
              return (_openBlock(), _createBlock(_unref(Slide), {
                class: "relative",
                key: sibling.id
              }, {
                default: _withCtx(() => [
                  _createVNode(NeighborhoodItem, {
                    sibling: sibling,
                    selectedNeighborhoodIds: _unref(selectedNeighborhoodIds),
                    neighborhoodLotsCount: _ctx.neighborhoodLotsCount(sibling.id),
                    neighborhoodSoldPercentage: neighborhoodSoldPercentage(sibling.id),
                    soldPercentage: _unref(soldPercentage),
                    isComingSoon: _unref(isComingSoon)(sibling),
                    coordinates: _unref(coordinates),
                    onLoadNeighborhood: loadNeighborhood,
                    onSelectNeighborhood: payload => selectNeighborhood(payload, idx),
                    onHideSibling: hideSibling,
                    onSethoverNeighborZoomLevel: sethoverNeighborZoomLevel,
                    onHighlightNeighborhood: highlightNeighborhood
                  }, null, 8, ["sibling", "selectedNeighborhoodIds", "neighborhoodLotsCount", "neighborhoodSoldPercentage", "soldPercentage", "isComingSoon", "coordinates", "onSelectNeighborhood"]),
                  (!_unref(isComingSoon)(sibling))
                    ? (_openBlock(), _createBlock(AppHeaderCircle, {
                        key: 0,
                        class: "progress-circle-absolute",
                        neighborhoodId: sibling.id,
                        soldPercentage: neighborhoodSoldPercentage(sibling.id)
                      }, null, 8, ["neighborhoodId", "soldPercentage"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 16, ["modelValue"])
      ]))
    : _createCommentVNode("", true)
}
}

})